import React, { useState, useEffect } from 'react';
import { OpenInferLogo } from './icons';

const WelcomeOverlay = ({ onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    // Wait for animation to complete before calling onClose
    setTimeout(onClose, 300);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div 
      className={`fixed inset-0 bg-black/50 backdrop-blur-sm z-[100] flex items-center justify-center transition-opacity duration-300 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
      onClick={handleOverlayClick}
    >
      <div 
        className={`bg-white rounded-2xl shadow-2xl max-w-2xl w-full mx-4 p-8 transform transition-all duration-300 ${
          isVisible ? 'scale-100 translate-y-0' : 'scale-95 translate-y-4'
        }`}
      >
        {/* Header with Logo */}
        <div className="mb-6 text-center">
          <div className="flex justify-center mb-4">
            <OpenInferLogo 
              className="text-brand-500" 
              color="#3B82F6"
              size={64}
            />
          </div>
          <h1 className="mb-2 text-3xl font-bold text-gray-900">
            Meet your Mementos
          </h1>
          <p className="text-lg text-gray-600">
            Every conversation creates a trail of meaning
          </p>
        </div>

        {/* Main Content */}
        <div className="mb-8 space-y-8 text-center">
          <div className="space-y-4">
            <p className="text-lg leading-relaxed text-gray-700">
              We call these pieces of the trail <strong className="text-gray-900">Mementos</strong>, the memory moments that form as you talk and interact with your 
              assistant. Each Memento captures context, intent, and outcomes. Together they link into a living 
              map of your work, ideas, and preferences.
            </p>
            <p className="text-lg leading-relaxed text-gray-700">
              This map is powerful. It shapes how well your AI companion understands you and how quickly it can help.
            </p>
          </div>

          <div className="space-y-4">
            <p className="text-base leading-relaxed text-gray-700">
              This site exists to show why that power belongs with you. You will see how much an assistant can learn, 
              how your Mementos connect to each other, and why owning and governing them matters for privacy, safety, and value creation.
            </p>
            <p className="text-base leading-relaxed text-gray-700">
              <strong className="text-gray-900">OpenInfer</strong> brings you that control. You get a high quality, local-first AI companion while you stay in charge 
              of your information. Critical Mementos stay on your device. You can choose what to share, you can delete anything, 
              and you can modify what is kept.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-center">
          <button
            onClick={handleClose}
            className="px-8 py-3 font-medium text-white rounded-xl shadow-sm transition-colors duration-200 bg-brand-500 hover:bg-brand-600"
          >
            Start Exploring
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeOverlay;
